import { DialogContent as ReactDialogContent } from "@certn/cascadia-react/components/modal/DialogContent";
import { memo } from "react";

import { CascadiaDialogContentProps } from "./types";

export const DialogContent = memo(function (props: CascadiaDialogContentProps) {
  return <ReactDialogContent {...props} />;
});
